// Visitor size filter: upper limit of small and medium, in the visitor's own unit
export const SIZE_BRACKET_LIMITS = {
  cm: [50, 100],
  inch: [20, 40]
}

export const SIZE_BRACKETS = ['small', 'medium', 'large']

// Custom size boxes: one from/to pair per side
export const SIZE_RANGE_SIDES = [
  { key: 'width', label: 'width', min: 'minWidth', max: 'maxWidth' },
  { key: 'height', label: 'height', min: 'minHeight', max: 'maxHeight' }
]
